export default __webpack_public_path__ + "static/media/detail_mobile_16_5.89f5bc6b.jpg";